const zbpb = [{
    path: 'zbpb_bclx',
    name: 'zbpb_bclx',
    component: () =>
              import('@/components/zbpb/bclx'),
    meta: { title: '班次类型', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'zbpb_bcgl',
    name: 'zbpb_bcgl',
    component: () =>
              import('@/components/zbpb/bcgl'),
    meta: { title: '班次管理', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'zbpb_pbzd',
    name: 'zbpb_pbzd',
    component: () =>
        import('@/components/zbpb/pbzd'),
    meta: { title: '排班制度', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'zbpb_pbgl',
    name: 'zbpb_pbgl',
    component: () =>
        import('@/components/zbpb/pbgl'),
    meta: { title: '排班管理', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'zbpb_pbfs',
    name: 'zbpb_pbfs',
    component: () =>
      import('@/components/zbpb/pbfs'),
    meta: { title: '排班方式', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'zbpb_bzgl',
    name: 'zbpb_bzgl',
    component: () =>
              import('@/components/zbpb/bzgl'),
    meta: { title: '班组管理', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'zbpb_zbgl',
    name: 'zbpb_zbgl',
    component: () =>
              import('@/components/zbpb/zbgl'),
    meta: { title: '值班管理', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'zbpb_qjjl',
    name: 'zbpb_qjjl',
    component: () =>
              import('@/components/zbpb/qjjl'),
    meta: { title: '请假记录', requireAuth: true, keepAlive: true, permission: true }
  },

  ]
  export default zbpb
  


// WEBPACK FOOTER //
// ./src/router/zbpb.js